<template>
  <div class="fc-wrap">

    <!-- ── Cabeçalho ── -->
    <div class="fc-header">
      <div class="fc-header-left">
        <div class="fc-header-icon">
          <svg width="16" height="16" viewBox="0 0 24 24" fill="none">
            <path d="M21 15a2 2 0 01-2 2H7l-4 4V5a2 2 0 012-2h14a2 2 0 012 2z" stroke="#E86A10" stroke-width="2" stroke-linejoin="round"/>
          </svg>
        </div>
        <div>
          <div class="fc-header-title">Fale Conosco</div>
          <div class="fc-header-sub">Preencha o formulário e entraremos em contato em breve</div>
        </div>
      </div>
    </div>

    <!-- ── Corpo ── -->
    <div class="fc-body">

      <!-- Coluna esquerda: info -->
      <div class="fc-info-col">
        <div class="fc-info-card">
          <div class="fc-info-badge">Suporte &amp; Vendas</div>
          <h2 class="fc-info-title">Como podemos<br>te ajudar?</h2>
          <p class="fc-info-desc">
            Nossa equipe está pronta para tirar suas dúvidas, apresentar demonstrações e ajudar você a extrair o máximo da plataforma.
          </p>

          <div class="fc-contact-items">
            <div class="fc-contact-item">
              <div class="fc-ci-icon">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><path d="M4 4h16c1.1 0 2 .9 2 2v12c0 1.1-.9 2-2 2H4c-1.1 0-2-.9-2-2V6c0-1.1.9-2 2-2z" stroke="#F5B935" stroke-width="2"/><polyline points="22,6 12,13 2,6" stroke="#F5B935" stroke-width="2"/></svg>
              </div>
              <div class="fc-ci-text">
                <span class="fc-ci-label">E-mail</span>
                <span class="fc-ci-val">suporte@vslbooster.com</span>
              </div>
            </div>

            <div class="fc-contact-item">
              <div class="fc-ci-icon">
                <svg width="14" height="14" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" stroke="#10B981" stroke-width="2"/><polyline points="12,6 12,12 16,14" stroke="#10B981" stroke-width="2" stroke-linecap="round"/></svg>
              </div>
              <div class="fc-ci-text">
                <span class="fc-ci-label">Horário de atendimento</span>
                <span class="fc-ci-val">Seg–Sex, 9h às 18h</span>
              </div>
            </div>
          </div>

          <!-- Decoração -->
          <div class="fc-info-deco">
            <div class="fc-deco-circle fc-deco-1"></div>
            <div class="fc-deco-circle fc-deco-2"></div>
          </div>
        </div>
      </div>

      <!-- Coluna direita: formulário -->
      <div class="fc-form-col">
        <div class="fc-form-card">
          <div v-if="success" class="fc-success">
            <div class="fc-success-icon">
              <svg width="32" height="32" viewBox="0 0 24 24" fill="none"><circle cx="12" cy="12" r="10" fill="rgba(16,185,129,0.15)"/><path d="M8 12l3 3 5-5" stroke="#10B981" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
            </div>
            <div class="fc-success-title">Mensagem enviada!</div>
            <div class="fc-success-desc">Recebemos seu contato e entraremos em breve pelo e-mail informado.</div>
            <button class="fc-btn-outline" @click="reset">Enviar outra mensagem</button>
          </div>

          <form v-else @submit.prevent="submit" class="fc-form">
            <h3 class="fc-form-title">Envie sua mensagem</h3>

            <div class="fc-row fc-row-2">
              <div class="fc-field">
                <label class="fc-label">Nome completo <span class="fc-req">*</span></label>
                <input v-model="form.full_name" type="text" class="fc-input" placeholder="João Silva" required />
              </div>
              <div class="fc-field">
                <label class="fc-label">E-mail <span class="fc-req">*</span></label>
                <input v-model="form.corporate_email" type="email" class="fc-input" placeholder="joao@empresa.com" required />
              </div>
            </div>

            <div class="fc-field">
              <label class="fc-label">WhatsApp</label>
              <input v-model="form.whatsapp" type="text" class="fc-input" placeholder="+55 11 99999-9999" />
            </div>

            <div class="fc-field">
              <label class="fc-label">Serviço de interesse <span class="fc-req">*</span></label>
              <div class="fc-select-wrap">
                <select v-model="form.service_interest" class="fc-select" required>
                  <option value="" disabled>Selecione...</option>
                  <option value="VSL Player">VSL Player</option>
                  <option value="Chat Booster">Chat Booster</option>
                  <option value="Webinário Simulator">Webinário Simulator</option>
                  <option value="Consultoria">Consultoria</option>
                  <option value="Suporte Técnico">Suporte Técnico</option>
                  <option value="Outro">Outro</option>
                </select>
                <svg class="fc-select-arrow" width="12" height="12" viewBox="0 0 24 24" fill="none"><path d="M6 9l6 6 6-6" stroke="#64748b" stroke-width="2" stroke-linecap="round"/></svg>
              </div>
            </div>

            <div class="fc-field">
              <label class="fc-label">Descrição da necessidade <span class="fc-req">*</span></label>
              <textarea v-model="form.necessity_description" class="fc-textarea" rows="4" placeholder="Descreva como podemos te ajudar..." required></textarea>
            </div>

            <div class="fc-form-footer">
              <span v-if="error" class="fc-error">{{ error }}</span>
              <button type="submit" class="fc-btn-submit" :disabled="loading">
                <span v-if="loading" class="fc-spinner"></span>
                <svg v-else width="15" height="15" viewBox="0 0 24 24" fill="none"><path d="M22 2L11 13M22 2L15 22l-4-9-9-4 20-7z" stroke="currentColor" stroke-width="2" stroke-linecap="round" stroke-linejoin="round"/></svg>
                {{ loading ? 'Enviando...' : 'Enviar mensagem' }}
              </button>
            </div>
          </form>
        </div>
      </div>

    </div>
  </div>
</template>

<script>
const WEBHOOK_URL = 'https://lemhnmzlsqnagxifipeh.supabase.co/functions/v1/form-webhook?company_id=17bdb966-12cc-4807-8483-d3aa01fa0dc9'
const COMPANY_ID  = '17bdb966-12cc-4807-8483-d3aa01fa0dc9'

export default {
  name: 'FaleConosco',
  data() {
    // Pré-preenche com dados do usuário logado
    let prefill = { full_name: '', corporate_email: '', whatsapp: '' }
    try {
      const u = JSON.parse(localStorage.getItem('userData') || '{}')
      const nome = [u.user_name, u.user_sobrenome].filter(Boolean).join(' ')
      prefill.full_name       = nome || u.name || ''
      prefill.corporate_email = u.user_email || u.email || ''
      prefill.whatsapp        = u.user_phone || ''
    } catch { /* ignore */ }

    return {
      loading: false,
      success: false,
      error: null,
      form: {
        full_name:             prefill.full_name,
        corporate_email:       prefill.corporate_email,
        whatsapp:              prefill.whatsapp,
        service_interest:      '',
        necessity_description: '',
      },
    }
  },
  methods: {
    async submit() {
      this.loading = true
      this.error   = null
      try {
        const res = await fetch(WEBHOOK_URL, {
          method:  'POST',
          headers: { 'Content-Type': 'application/json' },
          body: JSON.stringify({ company_id: COMPANY_ID, ...this.form }),
        })
        if (!res.ok) throw new Error(`Erro ${res.status}`)
        this.success = true
        this.$message({ type: 'success', message: 'Mensagem enviada com sucesso!' })
      } catch (e) {
        this.error = 'Falha ao enviar. Tente novamente ou nos contate diretamente.'
      } finally {
        this.loading = false
      }
    },
    reset() {
      this.success = false
      this.error   = null
      // Mantém os dados do usuário ao resetar
      let prefill = { full_name: '', corporate_email: '', whatsapp: '' }
      try {
        const u = JSON.parse(localStorage.getItem('userData') || '{}')
        const nome = [u.user_name, u.user_sobrenome].filter(Boolean).join(' ')
        prefill.full_name       = nome || u.name || ''
        prefill.corporate_email = u.user_email || u.email || ''
        prefill.whatsapp        = u.user_phone || ''
      } catch { /* ignore */ }
      this.form = { ...prefill, service_interest: '', necessity_description: '' }
    },
  },
}
</script>

<style scoped>
/* ══════════════════════════════════════
   Fale Conosco — dark navy
   ══════════════════════════════════════ */
.fc-wrap {
  display: flex;
  flex-direction: column;
  min-height: 100%;
  background: #0D1B2E;
  font-family: -apple-system, BlinkMacSystemFont, 'Inter', 'Segoe UI', sans-serif;
  color: #e2e8f0;
}

/* ── Header ── */
.fc-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 18px 28px 14px;
  border-bottom: 1px solid rgba(255,255,255,0.06);
  flex-wrap: wrap;
  gap: 10px;
}
.fc-header-left { display: flex; align-items: center; gap: 12px; }
.fc-header-icon {
  width: 38px; height: 38px; border-radius: 10px;
  background: rgba(232,106,16,0.12);
  border: 1px solid rgba(232,106,16,0.25);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.fc-header-title { font-size: 15px; font-weight: 800; color: #f1f5f9; }
.fc-header-sub   { font-size: 11px; color: #64748b; margin-top: 1px; }

/* ── Body layout ── */
.fc-body {
  display: grid;
  grid-template-columns: 340px 1fr;
  gap: 24px;
  padding: 28px;
  flex: 1;
}

/* ── Info card ── */
.fc-info-col { position: relative; }
.fc-info-card {
  background: linear-gradient(145deg, #0D3349 0%, #0a2540 100%);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 18px;
  padding: 32px 28px;
  position: sticky;
  top: 20px;
  overflow: hidden;
}
.fc-info-badge {
  display: inline-block;
  background: rgba(232,106,16,0.15);
  border: 1px solid rgba(232,106,16,0.3);
  color: #E86A10;
  font-size: 10px; font-weight: 800; letter-spacing: 1px;
  text-transform: uppercase;
  padding: 4px 10px; border-radius: 20px;
  margin-bottom: 20px;
}
.fc-info-title {
  font-size: 26px; font-weight: 900; color: #f1f5f9;
  line-height: 1.25; margin: 0 0 14px;
}
.fc-info-desc {
  font-size: 13px; color: #94a3b8; line-height: 1.6; margin: 0 0 28px;
}

.fc-contact-items { display: flex; flex-direction: column; gap: 16px; position: relative; z-index: 1; }
.fc-contact-item  { display: flex; align-items: center; gap: 12px; }
.fc-ci-icon {
  width: 36px; height: 36px; border-radius: 9px;
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.07);
  display: flex; align-items: center; justify-content: center; flex-shrink: 0;
}
.fc-ci-text { display: flex; flex-direction: column; gap: 1px; }
.fc-ci-label { font-size: 10px; font-weight: 700; color: #475569; text-transform: uppercase; letter-spacing: 0.6px; }
.fc-ci-val   { font-size: 13px; font-weight: 600; color: #cbd5e1; }

/* Decoração */
.fc-info-deco { position: absolute; bottom: -30px; right: -30px; z-index: 0; pointer-events: none; }
.fc-deco-circle { border-radius: 50%; position: absolute; }
.fc-deco-1 {
  width: 160px; height: 160px;
  background: radial-gradient(circle, rgba(232,106,16,0.08) 0%, transparent 70%);
  bottom: 0; right: 0;
}
.fc-deco-2 {
  width: 90px; height: 90px;
  background: radial-gradient(circle, rgba(245,185,53,0.06) 0%, transparent 70%);
  bottom: 60px; right: 80px;
}

/* ── Form card ── */
.fc-form-card {
  background: rgba(255,255,255,0.025);
  border: 1px solid rgba(255,255,255,0.07);
  border-radius: 18px;
  padding: 32px 30px;
}
.fc-form-title {
  font-size: 17px; font-weight: 800; color: #f1f5f9;
  margin: 0 0 24px;
}

.fc-form { display: flex; flex-direction: column; gap: 18px; }
.fc-row   { display: flex; gap: 16px; }
.fc-row-2 > .fc-field { flex: 1; min-width: 0; }

.fc-field { display: flex; flex-direction: column; gap: 6px; }
.fc-label {
  font-size: 11px; font-weight: 700; color: #94a3b8;
  text-transform: uppercase; letter-spacing: 0.7px;
}
.fc-req { color: #E86A10; }

.fc-input,
.fc-select,
.fc-textarea {
  background: rgba(255,255,255,0.05);
  border: 1px solid rgba(255,255,255,0.09);
  border-radius: 10px;
  padding: 11px 14px;
  font-size: 13.5px; color: #e2e8f0;
  font-family: inherit;
  outline: none;
  transition: border-color 0.2s, background 0.2s;
  width: 100%; box-sizing: border-box;
}
.fc-input::placeholder,
.fc-textarea::placeholder { color: #475569; }
.fc-input:focus,
.fc-select:focus,
.fc-textarea:focus {
  border-color: rgba(232,106,16,0.45);
  background: rgba(255,255,255,0.07);
}
.fc-textarea { resize: vertical; min-height: 96px; }

.fc-select-wrap { position: relative; }
.fc-select {
  appearance: none;
  padding-right: 36px;
  cursor: pointer;
  color-scheme: dark;
}
.fc-select-arrow {
  position: absolute; right: 12px; top: 50%; transform: translateY(-50%);
  pointer-events: none;
}
.fc-select option { background: #0D1B2E; color: #e2e8f0; }

/* ── Footer do form ── */
.fc-form-footer {
  display: flex; align-items: center; justify-content: space-between; flex-wrap: wrap; gap: 10px;
  padding-top: 4px;
}
.fc-error { font-size: 12px; color: #f87171; }

.fc-btn-submit {
  display: flex; align-items: center; gap: 8px;
  padding: 11px 24px; border-radius: 10px; border: none;
  background: linear-gradient(135deg, #E86A10, #F5B935);
  color: #fff; font-size: 13.5px; font-weight: 800;
  cursor: pointer; transition: opacity 0.2s; letter-spacing: 0.2px;
  white-space: nowrap;
}
.fc-btn-submit:hover:not(:disabled) { opacity: 0.88; }
.fc-btn-submit:disabled { opacity: 0.4; cursor: not-allowed; }

.fc-spinner {
  width: 14px; height: 14px; border-radius: 50%;
  border: 2px solid rgba(255,255,255,0.3);
  border-top-color: #fff;
  animation: spin 0.7s linear infinite;
}
@keyframes spin { to { transform: rotate(360deg); } }

/* ── Sucesso ── */
.fc-success {
  display: flex; flex-direction: column; align-items: center;
  justify-content: center; text-align: center;
  gap: 14px; padding: 48px 20px;
}
.fc-success-icon { margin-bottom: 4px; }
.fc-success-title { font-size: 20px; font-weight: 900; color: #f1f5f9; }
.fc-success-desc  { font-size: 13.5px; color: #94a3b8; max-width: 340px; line-height: 1.6; }

.fc-btn-outline {
  display: inline-flex; align-items: center; gap: 7px;
  padding: 10px 22px; border-radius: 10px;
  border: 1px solid rgba(232,106,16,0.4);
  background: rgba(232,106,16,0.08);
  color: #E86A10; font-size: 13px; font-weight: 700;
  cursor: pointer; transition: all 0.2s; margin-top: 6px;
}
.fc-btn-outline:hover { background: rgba(232,106,16,0.16); }

/* ── Responsivo ── */
@media (max-width: 900px) {
  .fc-body { grid-template-columns: 1fr; }
  .fc-info-card { position: static; }
}
@media (max-width: 600px) {
  .fc-row-2 { flex-direction: column; }
  .fc-body  { padding: 16px; }
  .fc-form-card { padding: 22px 18px; }
}
</style>
